(function () {
  if (window.FabCartAddFrame) return;

  var FRAME_ORDER = ['oak', 'black', 'brown', 'white', 'silver', 'gold'];
  var VISIBLE = 3;
  var XXL_ALLOWED = { black: true, white: true, oak: true };
  var FRAME_FALLBACK = {
    oak: 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-oak_ed6c9c02-05f5-48ec-9adc-45b9e03750af.png?v=1739214696',
    black: 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-black_4637193b-f661-4b4e-98f9-c67d418093da.png?v=1739214696',
    brown: 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-brown_87a233cc-c84d-463f-bd00-ec1107812378.png?v=1739214696',
    white: 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-white_a266ee0d-4989-4359-a984-f600b6c2ee22.png?v=1739214696',
    silver: 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-silver_25821ae4-2ead-45e6-898d-d91874e89943.png?v=1739214696',
    gold: 'https://cdn.shopify.com/s/files/1/0805/4970/8122/files/frame-gold_78a94671-4595-4552-a7d9-68f780307f1f.png?v=1739214696'
  };

  var FALLBACK_COPY = {
    add: 'Add a frame',
    change: 'Change frame',
    heading_add: 'Add a frame',
    heading_change: 'Change frame',
    headline: 'Make your print ready to hang.',
    support: 'Solid wood. Professionally framed. Arrives ready to hang.',
    frame_label: 'Frame: {name}',
    ready_to_hang: 'Ready to hang',
    keep_unframed: 'Keep print unframed',
    cancel: 'Cancel',
    cta_add: 'Add {name} frame · +{price}',
    cta_add_n: 'Add {count} {name} frames · +{price}',
    cta_update_plus: 'Update frame · +{price}',
    cta_update_same: 'Update frame · No extra charge',
    cta_update_save: 'Update frame · Save {price}',
    show_more: 'Show {n} more frames — {names}',
    error: 'Couldn’t update the frame. Try again.',
    unavailable: 'That frame isn’t available right now.',
    loading: 'Loading frames',
    recommended: 'Recommended',
    price_updated: 'The frame price changed. Confirm the new amount to continue.',
    success_add: 'Frame added to your print.',
    success_change: 'Frame updated.'
  };

  var productCache = {};
  var inflight = {};
  var stringCache = null;
  var configCache = null;
  var openRequest = 0;
  var submitting = false;
  var expanded = false;
  var state = null;
  var focusEl = null;
  var inertEls = [];

  function root() {
    return document.querySelector('[data-fab-cart-frame-modal]');
  }

  function storeRoot() {
    var path = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return path.charAt(path.length - 1) === '/' ? path : path + '/';
  }

  function copyMap() {
    if (stringCache) return stringCache;
    var el = document.querySelector('[data-fab-cart-frame-strings]');
    try {
      stringCache = el ? JSON.parse(el.textContent || '{}') : {};
    } catch (e) {
      stringCache = {};
    }
    return stringCache;
  }

  function config() {
    if (configCache) return configCache;
    var el = document.querySelector('[data-fab-cart-frame-config]');
    try {
      configCache = el ? JSON.parse(el.textContent || '{}') : {};
    } catch (e) {
      configCache = {};
    }
    return configCache;
  }

  function t(key, vars) {
    var text = copyMap()[key] || FALLBACK_COPY[key] || key;
    Object.keys(vars || {}).forEach(function (name) {
      text = String(text).replace(new RegExp('\\{\\{\\s*' + name + '\\s*\\}\\}', 'g'), vars[name]);
      text = String(text).replace(new RegExp('\\{' + name + '\\}', 'g'), vars[name]);
    });
    return text;
  }

  function formatMoney(cents) {
    var n = Number(cents);
    if (isNaN(n)) return '';
    var settings = config();
    if (settings.currency && window.Intl && typeof window.Intl.NumberFormat === 'function') {
      try {
        return new window.Intl.NumberFormat(settings.locale || undefined, {
          style: 'currency',
          currency: settings.currency
        }).format(Math.abs(n) / 100);
      } catch (e) {
        // Fall through for browsers that reject the locale or currency code.
      }
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var moneyFormat = settings.currencySymbol
        ? settings.currencySymbol + '{{amount}}'
        : (window.theme && window.theme.moneyFormat) || window.Shopify.money_format || '${{amount}}';
      return window.Shopify.formatMoney(Math.abs(n), moneyFormat);
    }
    return (settings.currencySymbol || '') + (Math.abs(n) / 100).toFixed(2);
  }

  function variantCents(variant) {
    var price = variant && variant.price;
    if (price == null || price === '') return null;
    if (typeof price === 'string' && price.indexOf('.') !== -1) {
      var dollars = parseFloat(price);
      return isNaN(dollars) ? null : Math.round(dollars * 100);
    }
    var n = Number(price);
    return isNaN(n) ? null : n;
  }

  function sizePrefix(title) {
    var parts = String(title || '').split(' / ');
    if (parts.length >= 3) return parts[0].trim() + ' / ' + parts[1].trim();
    if (parts.length === 2) return parts[0].trim();
    return String(title || '');
  }

  function variantOptions(variant) {
    if (variant && Array.isArray(variant.options) && variant.options.length) return variant.options;
    return [variant && variant.option1, variant && variant.option2, variant && variant.option3].filter(function (value) {
      return value != null && value !== '';
    });
  }

  function parseOptionsAttr(raw) {
    try {
      var parsed = JSON.parse(raw || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function frameIndexFromProduct(product, fallback) {
    var names = (product && product.options) || [];
    for (var i = 0; i < names.length; i++) {
      if (/frame|color|couleur|farbe|cornice|marco|lijst|rahmen|cadre/i.test(String(names[i]))) return i;
    }
    if (fallback >= 0) return fallback;
    return Math.max(0, names.length - 1);
  }

  function sameNonFrameOptions(variant, selected, frameIndex) {
    var opts = variantOptions(variant);
    var sel = selected || [];
    var len = Math.max(opts.length, sel.length);
    for (var i = 0; i < len; i++) {
      if (i === frameIndex) continue;
      if (String(opts[i] || '') !== String(sel[i] || '')) return false;
    }
    return true;
  }

  function frameValue(variant, frameIndex) {
    var opts = variantOptions(variant);
    if (frameIndex >= 0 && opts[frameIndex] != null) return opts[frameIndex];
    return String((variant && variant.title) || '').split(' / ').pop();
  }

  function frameKeyFromTitle(title) {
    var raw = String(title || '').split(' / ').pop().toLowerCase().trim();
    if (/unframed|none|sans|ohne|senza|zonder|utan/.test(raw)) return 'unframed';
    if (/black|noir|schwarz|nero|zwart|svart|negro/.test(raw)) return 'black';
    if (/white|blanc|weiß|weiss|bianco|wit|vit|blanco/.test(raw)) return 'white';
    if (/oak|chêne|roble|eiche|rovere|eiken|eik|ek/.test(raw)) return 'oak';
    if (/brown|walnut|marron|marrón|marrone|braun|bruin|brun/.test(raw)) return 'brown';
    if (/silver|argent|silber|argento|zilver|plata/.test(raw)) return 'silver';
    if (/gold|or|doré|oro|goud|guld|dorado/.test(raw)) return 'gold';
    return raw.replace(/\s+/g, '-');
  }

  function frameLabel(key, variant) {
    var last = String((variant && (variant.title || variant.name)) || '').split(' / ').pop();
    if (last && frameKeyFromTitle(last) === key) return last.trim();
    return key.charAt(0).toUpperCase() + key.slice(1);
  }

  function variantImage(variant) {
    var image = variant && variant.featured_image;
    if (!image) return '';
    if (typeof image === 'string') return image;
    return image.src || image.url || '';
  }

  function sizedImage(url, width) {
    url = String(url || '');
    if (!url) return '';
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + width);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function isXxlSize(prefix) {
    if (window.FabSizeKey && typeof window.FabSizeKey.isXxlSizeKey === 'function') {
      return window.FabSizeKey.isXxlSizeKey(prefix);
    }
    return /36\s*x\s*48|90\s*x\s*120/i.test(prefix || '');
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    if (inflight[handle]) return inflight[handle];
    inflight[handle] = fetch(storeRoot() + 'products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
    }).then(function (res) {
      if (!res.ok) throw new Error('Product request failed');
      return res.json();
    }).then(function (product) {
      productCache[handle] = product;
      delete inflight[handle];
      return product;
    }, function (err) {
      delete inflight[handle];
      throw err;
    });
    return inflight[handle];
  }

  function fetchCart() {
    return fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', {
      credentials: 'same-origin',
    }).then(function (res) {
      if (!res.ok) throw new Error('cart failed');
      return res.json();
    });
  }

  function lineItem(cart, key) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].key) === String(key)) return items[i];
    }
    return null;
  }

  function optionsFor(product, selected, frameIndex, unframedCents, recommended, sizeKey, includeUnframed) {
    var xxl = isXxlSize(sizeKey);
    var list = [];
    (product.variants || []).forEach(function (variant) {
      if (!variant) return;
      if (!sameNonFrameOptions(variant, selected, frameIndex)) return;
      var key = frameKeyFromTitle(frameValue(variant, frameIndex));
      if (key === 'unframed' && !includeUnframed) return;
      if (key !== 'unframed' && xxl && !XXL_ALLOWED[key]) return;
      var price = variantCents(variant);
      var upgrade = unframedCents == null || price == null ? null : price - unframedCents;
      var image = variantImage(variant);
      var corner = FRAME_FALLBACK[key] || '';
      var swatch = corner || image;
      list.push({
        key: key,
        variant: variant,
        variantId: String(variant.id),
        label: key === 'unframed' ? t('keep_unframed') : frameLabel(key, variant),
        benefit: key === 'unframed' ? '' : t('ready_to_hang'),
        upgrade: upgrade,
        unavailable: variant.available === false || upgrade == null,
        recommended: !!(recommended && key === recommended),
        preview: sizedImage(image || corner, 800),
        swatch: sizedImage(swatch, 400),
        available: variant.available !== false
      });
    });
    list.sort(function (a, b) {
      var av = FRAME_ORDER.indexOf(a.key);
      var bv = FRAME_ORDER.indexOf(b.key);
      return (av === -1 ? 20 : av) - (bv === -1 ? 20 : bv);
    });
    var seen = {};
    return list.filter(function (option) {
      if (seen[option.key]) return false;
      seen[option.key] = true;
      return true;
    });
  }

  function unframedVariant(product, selected, frameIndex) {
    var found = null;
    (product.variants || []).some(function (variant) {
      if (!sameNonFrameOptions(variant, selected, frameIndex)) return false;
      if (frameKeyFromTitle(frameValue(variant, frameIndex)) !== 'unframed') return false;
      found = variant;
      return true;
    });
    return found;
  }

  function selectedOption() {
    if (!state) return null;
    for (var i = 0; i < state.options.length; i++) {
      if (state.options[i].key === state.selectedKey) return state.options[i];
    }
    return state.options[0] || null;
  }

  function currentOption() {
    if (!state) return null;
    for (var i = 0; i < state.options.length; i++) {
      if (state.options[i].variantId === String(state.variantId)) return state.options[i];
    }
    return null;
  }

  function visibleOptions() {
    if (!state) return [];
    return state.options.filter(function (option, index) {
      if (option.unavailable) return false;
      return expanded || index < VISIBLE;
    });
  }

  function quoteDelta(option) {
    if (!state || !option || option.upgrade == null) return null;
    if (state.mode !== 'change') return option.upgrade;
    var current = currentOption();
    var currentUpgrade = current && current.upgrade != null ? current.upgrade : 0;
    return option.upgrade - currentUpgrade;
  }

  function setStatus(text, isError) {
    var el = root() && root().querySelector('[data-fab-cart-frame-status]');
    if (!el) return;
    if (!text) {
      el.hidden = true;
      el.textContent = '';
      return;
    }
    el.hidden = false;
    el.textContent = text;
    el.style.color = isError ? '#8a1f11' : '#5c5854';
  }

  function setError(text) {
    var el = root() && root().querySelector('[data-fab-cart-frame-error]');
    if (!el) return;
    el.hidden = !text;
    el.textContent = text || '';
  }

  function announce(text) {
    var el = document.querySelector('[data-fab-cart-frame-live]');
    if (!el || !text) return;
    el.textContent = '';
    window.setTimeout(function () { el.textContent = text; }, 20);
  }

  function renderCards() {
    var modal = root();
    if (!modal || !state) return;
    var grid = modal.querySelector('[data-fab-cart-frame-grid]');
    var more = modal.querySelector('[data-fab-cart-frame-more]');
    var hiddenKeys = [];
    var html = '';
    state.options.forEach(function (option, index) {
      var extra = index >= VISIBLE;
      if (extra && !expanded) {
        hiddenKeys.push(option.label);
        return;
      }
      html +=
        '<button type="button" class="fab-cart-frame__card' +
        (option.key === state.selectedKey ? ' is-selected' : '') +
        (option.unavailable ? ' is-unavailable' : '') +
        '" role="radio" aria-checked="' + (option.key === state.selectedKey ? 'true' : 'false') +
        '" data-fab-cart-frame-option="' + option.key + '"' +
        (option.unavailable ? ' disabled' : '') +
        ' aria-label="' + option.label + (option.benefit ? ', ' + option.benefit : '') + (option.upgrade > 0 ? ', +' + formatMoney(option.upgrade) : '') + '">' +
        (option.recommended ? '<span class="fab-cart-frame__badge">' + t('recommended') + '</span>' : '') +
        '<span class="fab-cart-frame__swatch"' +
        (option.swatch ? ' style="background-image:url(\'' + option.swatch.replace(/'/g, '%27') + '\')"' : '') + '>' +
        (option.swatch ? '<img src="' + option.swatch + '" alt="" width="400" height="400" loading="lazy" decoding="async">' : '') +
        '</span>' +
        '<span class="fab-cart-frame__info">' +
          '<span class="fab-cart-frame__name">' + option.label + '</span>' +
          (option.benefit ? '<span class="fab-cart-frame__benefit">' + option.benefit + '</span>' : '') +
          (option.upgrade > 0 && !option.unavailable ? '<span class="fab-cart-frame__price">+' + formatMoney(option.upgrade) + '</span>' : '') +
        '</span>' +
      '</button>';
    });
    grid.innerHTML = html;
    if (hiddenKeys.length && !expanded) {
      more.hidden = false;
      more.textContent = t('show_more', { n: String(hiddenKeys.length), names: hiddenKeys.join(', ') });
    } else {
      more.hidden = true;
    }
  }

  function renderFooter() {
    var modal = root();
    if (!modal || !state) return;
    var option = selectedOption();
    var submit = modal.querySelector('[data-fab-cart-frame-submit]');
    var secondary = modal.querySelector('[data-fab-cart-frame-secondary]');
    var selected = modal.querySelector('[data-fab-cart-frame-selected]');
    var art = modal.querySelector('[data-fab-cart-frame-art]');
    if (selected && option) selected.textContent = t('frame_label', { name: option.label });
    if (art) {
      if (option && option.preview) {
        art.hidden = false;
        art.src = option.preview;
        art.alt = option.label;
      } else {
        art.removeAttribute('src');
        art.alt = '';
      }
    }
    if (!option || option.unavailable) {
      submit.disabled = true;
      submit.textContent = t('unavailable');
      state.quotedUpgrade = null;
      return;
    }
    var qty = state.quantity || 1;
    var delta = quoteDelta(option);
    state.quotedUpgrade = option.upgrade;
    state.quotedDelta = delta;
    if (state.mode === 'change') {
      if (option.variantId === String(state.variantId)) {
        submit.disabled = true;
        submit.textContent = t('cta_update_same');
      } else if (delta > 0) {
        submit.disabled = false;
        submit.textContent = t('cta_update_plus', { price: formatMoney(delta * qty) });
      } else if (delta < 0) {
        submit.disabled = false;
        submit.textContent = t('cta_update_save', { price: formatMoney(delta * qty) });
      } else {
        submit.disabled = false;
        submit.textContent = t('cta_update_same');
      }
      secondary.textContent = t('cancel');
      return;
    }
    submit.disabled = false;
    if (qty === 1) submit.textContent = t('cta_add', { name: option.label, price: formatMoney(delta) });
    else submit.textContent = t('cta_add_n', { count: String(qty), name: option.label, price: formatMoney(delta * qty) });
    secondary.textContent = t('keep_unframed');
  }

  function paint() {
    renderCards();
    renderFooter();
  }

  function setBusy(busy) {
    var modal = root();
    if (!modal) return;
    submitting = !!busy;
    modal.classList.toggle('is-busy', !!busy);
    modal.setAttribute('aria-busy', busy ? 'true' : 'false');
    var submit = modal.querySelector('[data-fab-cart-frame-submit]');
    if (submit && busy) submit.disabled = true;
  }

  function setBackgroundInert(on) {
    inertEls.forEach(function (el) {
      if (el) el.removeAttribute('inert');
    });
    inertEls = [];
    if (!on) return;
    ['cart-drawer', '#MainContent', 'main-cart-footer'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el && !el.contains(root())) {
        el.setAttribute('inert', '');
        inertEls.push(el);
      }
    });
  }

  function restoreDrawerFocus() {
    var drawer = document.querySelector('cart-drawer.active');
    if (drawer && typeof trapFocus === 'function') {
      var container = typeof drawer.trapContainer !== 'undefined'
        ? drawer.trapContainer
        : document.getElementById('CartDrawer');
      trapFocus(container || drawer, focusEl || drawer);
      return;
    }
    if (focusEl && document.contains(focusEl) && typeof focusEl.focus === 'function') {
      try { focusEl.focus(); } catch (e) {}
    }
  }

  function openModal() {
    var modal = root();
    if (!modal) return;
    modal.hidden = false;
    document.documentElement.classList.add('fab-cart-frame-open');
    setBackgroundInert(true);
    var closeBtn = modal.querySelector('[data-fab-cart-frame-close]');
    if (typeof trapFocus === 'function') trapFocus(modal.querySelector('.fab-cart-frame__sheet'), closeBtn || modal);
    else if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    var modal = root();
    submitting = false;
    openRequest += 1;
    if (modal) {
      modal.hidden = true;
      modal.classList.remove('is-busy');
      modal.setAttribute('aria-busy', 'false');
    }
    document.documentElement.classList.remove('fab-cart-frame-open');
    setBackgroundInert(false);
    if (typeof removeTrapFocus === 'function') removeTrapFocus();
    restoreDrawerFocus();
    state = null;
  }

  function defaultKey(options, recommended, currentKey, mode) {
    if (mode === 'change' && currentKey && currentKey !== 'unframed') {
      for (var i = 0; i < options.length; i++) if (options[i].key === currentKey) return currentKey;
    }
    if (recommended) {
      for (var r = 0; r < options.length; r++) {
        if (options[r].key === recommended && !options[r].unavailable) return recommended;
      }
    }
    for (var o = 0; o < FRAME_ORDER.length; o++) {
      for (var j = 0; j < options.length; j++) {
        if (options[j].key === FRAME_ORDER[o] && !options[j].unavailable) return FRAME_ORDER[o];
      }
    }
    return options[0] && options[0].key;
  }

  function cleanProps(props) {
    var out = {};
    function add(key, value) {
      if (key == null || value == null || value === '') return;
      key = String(key);
      out[key] = String(value);
    }
    function addMalformedPair(key, value) {
      if (!/^\d+$/.test(String(key))) return false;
      var match = String(value).match(/^(_[^,]+),(.*)$/);
      if (!match) return false;
      add(match[1], match[2]);
      return true;
    }
    if (Array.isArray(props)) {
      props.forEach(function (pair) {
        if (!Array.isArray(pair) || pair.length < 2) return;
        if (addMalformedPair(pair[0], pair[1])) return;
        add(pair[0], pair[1]);
      });
      return out;
    }
    Object.keys(props || {}).forEach(function (key) {
      var value = props[key];
      if (addMalformedPair(key, value)) return;
      add(key, value);
    });
    return out;
  }

  function parsedProps(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return null; }
  }

  function readProps(button) {
    var host = button.closest('tr, .cart-item') || button.parentElement;
    var el = host && host.querySelector('[data-fab-cart-frame-props]');
    if (!el) return {};
    return cleanProps(parsedProps(el) || {});
  }

  function openFromButton(button) {
    var modal = root();
    if (!modal || !button) return;
    focusEl = button;
    expanded = false;
    submitting = false;
    setError('');
    setStatus(t('loading'));
    announce(t('loading'));
    var request = ++openRequest;
    var handle = button.getAttribute('data-handle');
    var prefix = button.getAttribute('data-size-prefix') || '';
    var selectedOptions = parseOptionsAttr(button.getAttribute('data-options'));
    var rawIndex = button.getAttribute('data-frame-index');
    var frameIndexAttr = rawIndex === '' || rawIndex == null || isNaN(Number(rawIndex)) ? -1 : Number(rawIndex);
    var mode = button.getAttribute('data-mode') || 'add';
    var recommended = String(button.getAttribute('data-recommended') || '').toLowerCase();
    var titleEl = modal.querySelector('[data-fab-cart-frame-title]');
    if (titleEl) titleEl.textContent = mode === 'change' ? t('heading_change') : t('heading_add');
    openModal();
    fetchProduct(handle).then(function (product) {
      if (request !== openRequest) return;
      if (!product) throw new Error('missing product');
      var frameIndex = frameIndexFromProduct(product, frameIndexAttr);
      if (!selectedOptions.length) {
        var current = null;
        (product.variants || []).some(function (variant) {
          if (String(variant.id) === String(button.getAttribute('data-variant-id'))) {
            current = variant;
            return true;
          }
          return false;
        });
        selectedOptions = variantOptions(current || (product.variants || [])[0] || {});
      }
      var size = prefix || sizePrefix((selectedOptions || []).join(' / '));
      var unframed = unframedVariant(product, selectedOptions, frameIndex);
      var unframedCents = variantCents(unframed);
      var options = optionsFor(product, selectedOptions, frameIndex, unframedCents, recommended, size, mode === 'change');
      if (!options.length || unframedCents == null) throw new Error('no frames');
      state = {
        mode: mode,
        handle: handle,
        lineKey: button.getAttribute('data-line-key'),
        variantId: button.getAttribute('data-variant-id'),
        quantity: Number(button.getAttribute('data-quantity') || 1) || 1,
        sellingPlan: button.getAttribute('data-selling-plan') || '',
        properties: readProps(button),
        selectedOptions: selectedOptions,
        frameIndex: frameIndex,
        sizeKey: size,
        options: options,
        selectedKey: defaultKey(options, recommended, button.getAttribute('data-frame-key'), mode),
        unframedCents: unframedCents
      };
      setStatus('');
      paint();
    }).catch(function () {
      if (request !== openRequest) return;
      setStatus(t('unavailable'), true);
    });
  }

  function changeLine(key, quantity, properties) {
    var body = { id: key, quantity: quantity };
    if (properties) body.properties = properties;
    return fetch((window.routes && window.routes.cart_change_url) || '/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || json.status >= 400) throw new Error(json.description || json.message || 'change failed');
        return json;
      });
    });
  }

  function addItem(payload) {
    return fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload),
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || json.status >= 400) throw new Error(json.description || json.message || 'add failed');
        return json;
      });
    });
  }

  function refreshCart() {
    var items = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
    var done = items && typeof items.onCartUpdate === 'function' ? items.onCartUpdate() : Promise.resolve();
    return Promise.resolve(done).then(function () {
      document.dispatchEvent(new CustomEvent('fab:cart-updated', {
        detail: { root: document.querySelector('cart-drawer') || document },
      }));
    });
  }

  function addPayloadForLine(item) {
    var payload = {
      id: Number(item.variant_id),
      quantity: Number(item.quantity) || 1,
      properties: item.properties || {}
    };
    var allocation = item.selling_plan_allocation;
    var sellingPlan = allocation && allocation.selling_plan;
    if (sellingPlan && sellingPlan.id) payload.selling_plan = Number(sellingPlan.id);
    return payload;
  }

  function restoreLine(item, originalError) {
    return addItem({ items: [addPayloadForLine(item)] }).then(function () {
      throw originalError;
    }, function () {
      throw originalError;
    });
  }

  function matchingPayloadQuantity(cart, payload) {
    var expectedProps = payload.properties || {};
    return ((cart && cart.items) || []).reduce(function (total, item) {
      if (String(item.variant_id) !== String(payload.id)) return total;
      var props = item.properties || {};
      var matches = Object.keys(expectedProps).every(function (key) {
        return String(props[key]) === String(expectedProps[key]);
      });
      return matches ? total + (Number(item.quantity) || 0) : total;
    }, 0);
  }

  function swapLine(match) {
    var payload = {
      id: Number(match.variantId),
      quantity: state.quantity,
      properties: state.properties || {}
    };
    if (state.sellingPlan) payload.selling_plan = Number(state.sellingPlan);
    var originalKey = state.lineKey;
    return fetchCart().then(function (cart) {
      var live = lineItem(cart, originalKey);
      if (!live || String(live.variant_id) !== String(state.variantId)) throw new Error('stale');
      if (Number(live.quantity) !== Number(state.quantity)) {
        state.quantity = Number(live.quantity) || 1;
        return { reconcile: true };
      }
      var replacementQuantityBefore = matchingPayloadQuantity(cart, payload);
      return changeLine(originalKey, 0).then(function () {
        return addItem({ items: [payload] }).catch(function (err) {
          return restoreLine(live, err);
        });
      }).then(function () {
        return fetchCart();
      }).then(function (after) {
        var replacementQuantity = matchingPayloadQuantity(after, payload);
        if (replacementQuantity < replacementQuantityBefore + payload.quantity) {
          return restoreLine(live, new Error('replacement removed'));
        }
        return after;
      });
    });
  }

  function confirm() {
    if (!state || submitting) return;
    var option = selectedOption();
    if (!option || option.unavailable) return;
    if (state.mode === 'change' && option.variantId === String(state.variantId)) return;
    var quotedUpgrade = state.quotedUpgrade;
    setBusy(true);
    setError('');
    fetchProduct(state.handle).then(function (product) {
      var selected = state.selectedOptions || variantOptions(option.variant);
      var frameIndex = state.frameIndex;
      if (frameIndex == null) frameIndex = frameIndexFromProduct(product, -1);
      var unframed = unframedVariant(product, selected, frameIndex);
      var unframedCents = variantCents(unframed);
      if (unframedCents == null) throw new Error('unavailable');
      var fresh = optionsFor(product, selected, frameIndex, unframedCents, '', state.sizeKey, state.mode === 'change');
      var match = null;
      fresh.forEach(function (item) { if (item.key === option.key) match = item; });
      if (!match || match.unavailable) throw new Error('unavailable');
      if (match.upgrade !== quotedUpgrade) {
        state.options = fresh;
        state.selectedKey = match.key;
        state.unframedCents = unframedCents;
        setBusy(false);
        paint();
        setStatus(t('price_updated'));
        announce(t('price_updated'));
        return null;
      }
      return swapLine(match);
    }).then(function (result) {
      if (result == null) return;
      if (result.reconcile) {
        setBusy(false);
        paint();
        setStatus(t('price_updated'));
        announce(t('price_updated'));
        return;
      }
      var successCopy = state.mode === 'change' ? t('success_change') : t('success_add');
      return refreshCart().then(function () {
        announce(successCopy);
        closeModal();
      });
    }).catch(function () {
      setBusy(false);
      if (state) paint();
      setError(t('error'));
    });
  }

  function moveSelection(step) {
    var options = visibleOptions();
    if (!options.length) return;
    var index = 0;
    for (var i = 0; i < options.length; i++) {
      if (options[i].key === state.selectedKey) index = i;
    }
    var next = options[(index + step + options.length) % options.length];
    state.selectedKey = next.key;
    setError('');
    paint();
    var btn = root() && root().querySelector('[data-fab-cart-frame-option="' + next.key + '"]');
    if (btn) btn.focus();
  }

  function bind() {
    var modal = root();
    if (modal && modal.parentElement !== document.body) document.body.appendChild(modal);
    document.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-fab-cart-frame]');
      if (openBtn) {
        event.preventDefault();
        openFromButton(openBtn);
        return;
      }
      var modal = root();
      if (!modal || modal.hidden) return;
      if (event.target.closest('[data-fab-cart-frame-close]') || event.target.closest('[data-fab-cart-frame-overlay]') || event.target.closest('[data-fab-cart-frame-secondary]')) {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.target.closest('[data-fab-cart-frame-more]')) {
        event.preventDefault();
        expanded = true;
        paint();
        return;
      }
      var choice = event.target.closest('[data-fab-cart-frame-option]');
      if (choice && !choice.disabled) {
        event.preventDefault();
        state.selectedKey = choice.getAttribute('data-fab-cart-frame-option');
        setError('');
        setStatus('');
        paint();
        return;
      }
      if (event.target.closest('[data-fab-cart-frame-submit]')) {
        event.preventDefault();
        confirm();
      }
    });
    document.addEventListener('keydown', function (event) {
      var modal = root();
      if (!modal || modal.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        closeModal();
        return;
      }
      if (!state) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        if (!event.target.closest('[data-fab-cart-frame-grid]')) return;
        event.preventDefault();
        moveSelection(1);
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        if (!event.target.closest('[data-fab-cart-frame-grid]')) return;
        event.preventDefault();
        moveSelection(-1);
      }
    }, true);
  }

  bind();
  window.FabCartAddFrame = { open: openFromButton, close: closeModal };
})();
